import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useWorkspace } from "./WorkspaceContext";

// Tags — classes spin-off (separate collection, separate sidebar section).
// Same schema (id, name, color, parent_folder_id, position) but distinct from
// classes so users can categorise across multiple axes.
const TagsContext = createContext(null);

export function TagsProvider({ children }) {
  const { current } = useWorkspace();
  const [tags, setTags] = useState([]);

  const load = useCallback(async () => {
    if (!current) return setTags([]);
    try {
      const { data } = await api.get(`/workspaces/${current.workspace_id}/tags`);
      setTags(data);
    } catch { /* noop */ }
  }, [current]);

  useEffect(() => { load(); }, [load]);

  const create = async (body) => {
    const { data } = await api.post(`/workspaces/${current.workspace_id}/tags`, body);
    setTags((prev) => [...prev, data]);
    return data;
  };
  const update = async (tag_id, body) => {
    const { data } = await api.put(`/workspaces/${current.workspace_id}/tags/${tag_id}`, body);
    setTags((prev) => prev.map((t) => t.tag_id === tag_id ? data : t));
    return data;
  };
  const remove = async (tag_id) => {
    await api.delete(`/workspaces/${current.workspace_id}/tags/${tag_id}`);
    setTags((prev) => prev.filter((t) => t.tag_id !== tag_id));
  };

  return (
    <TagsContext.Provider value={{ tags, setTags, create, update, remove, reload: load }}>
      {children}
    </TagsContext.Provider>
  );
}

export const useTags = () => useContext(TagsContext);
